import React, { Component } from "react";
import "./CarForm.css";

import store from "../../store";
import { Route, Link, BrowserRouter as Router } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import PropTypes, { array } from "prop-types";

import Button from "@material-ui/core/Button";
import { fade, makeStyles, withStyles } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";

import Paper from "@material-ui/core/Paper";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

import { createMuiTheme } from "@material-ui/core/styles";
import red from "@material-ui/core/colors/red";
import CarFormDetail from "../CarFormDetail/CarFormDetail";
import CarFormNumbers from "../CarFormNumbers/CarFormNumbers";

import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import Checkbox from "@material-ui/core/Checkbox";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { isMobile } from "react-device-detect";
import MaskedInput from "react-text-mask";
import NumberFormat from "react-number-format";
import TextField from "@material-ui/core/TextField";

const api = process.env.REACT_APP_API;

const ColorButton = withStyles(theme => ({
  root: {
    fontFamily: "ToyotaRegular",
    fontWeight: "bold",
    borderColor: red[500],
    backgroundColor: red[500],
    color: theme.palette.getContrastText(red[50]),
    color: red[50],
    borderRadius: 20,
    "&:hover": {
      backgroundColor: red[100],
      color: theme.palette.getContrastText(red[500]),
      color: red[700]
    }
  }
}))(Button);

const imgStyle = {
  width: "50%",
  height: "50%",
  display: "block",
  marginLeft: "auto",
  marginRight: "auto"
};

const BootstrapInput = withStyles(theme => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(3)
    }
  },
  input: {
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid rgba(179, 179, 179, 0.2)",
    color: "rgba(120, 120, 120, 1)",
    fontSize: "0.7rem",
    width: "100%",
    padding: "10px 12px",
    borderRadius: "0px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    fontFamily: "ToyotaRegular",
    "&:focus": {
      boxShadow: `${fade(theme.palette.primary.main, 0.1)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main
    }
  }
}))(InputBase);

class CarForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      accept: false,
      step: 1,
      car: JSON.parse(localStorage.getItem("selectedCar")),
      reserva: "",
      tarjetas: [],
      bancos: [],
      tipoTarjeta: "",
      banco: "",
      tarjeta: "",
      numTarjeta: "",
      fechaVencimiento: "",
      codSeguridad: "",
      titularTarjeta: "",
      documentoTarjeta: "",
      emailContacto: "",
      emailContacto2: "",
      areaTelefonoContacto: "",
      telefonoContacto: ""
    };
  }

  handleChange = event => {};

  componentDidMount() {
    this.getData();
    /*fetch("json/pagos.json")
      .then(r => r.json())
      .then(data => {
        this.setState({
          bancos: data.bancos,
          tarjetas: data.tarjetas
        });
      });*/
  }

  getData = () => {
    this.fetchBancos()
      .then(res => {
        let bancos = [];
        for (let i = 0; i < res.data.length; i++) {
          bancos.push(res.data[i].banco);
        }

        this.setState({ tarjetas: res.data, bancos: bancos });
      })
      .catch(err => console.log(err));
  };

  fetchBancos = async () => {
    const response = await fetch(api + "tarjetas");
    const res = await response.json();
    if (response.status !== 200) {
      throw Error(response.message);
    }
    return res;
  };

  handleChangeCheck = () => {
    let a = this.state.accept;
    this.setState({ accept: !a });
  };

  useStyles = () =>
    makeStyles(theme => ({
      button: {
        margin: theme.spacing(1),
        primary: red
      },
      input: {
        display: "none"
      }
    }));

  handleOpen = () => {
    this.setState({ open: true });
  };
  handleClose = () => {
    this.setState({ open: false, accept: false });
  };
  handleAccept = () => {
    this.setState({ open: false, accept: true });
  };

  handleChangeCheck = () => {
    let a = this.state.accept;
    this.setState({ accept: !a });
  };

  next = () => {
    var error = false;
    console.log(this.state.step);
    if (this.state.step === 1) {
      if (this.state.reserva === "") {
        this.setState({
          errorMessage: "*COMPLETAR TODOS LOS CAMPOS",
          error: true
        });
        error = true;
      }
      if (parseInt(this.state.reserva) < 5000) {
        this.setState({
          errorMessage: "*EL MONTO MÍNIMO ES DE $5000",
          error: true
        });
        error = true;
      }
    } else if (this.state.step === 2) {
      if (
        this.state.tipoTarjeta === "" ||
        this.state.banco === "" ||
        this.state.tarjeta === "" ||
        this.state.numTarjeta === "" ||
        this.state.fechaVencimiento === "" ||
        this.state.codSeguridad === "" ||
        this.state.titularTarjeta === "" ||
        this.state.documentoTarjeta === ""
      ) {
        this.setState({
          errorMessage: "*COMPLETAR TODOS LOS CAMPOS",
          error: true
        });
        error = true;
      }
    } else if (this.state.step === 3) {
      if (
        this.state.emailContacto === "" ||
        this.state.emailContacto2 === "" ||
        this.state.areaTelefonoContacto === "" ||
        this.state.telefonoContacto === ""
      ) {
        this.setState({
          errorMessage: "*COMPLETAR TODOS LOS CAMPOS",
          error: true
        });
        error = true;
      } else if (this.state.emailContacto !== this.state.emailContacto2) {
        this.setState({
          errorMessage: "*LOS E-MAILS NO COINCIDEN",
          error: true
        });
        error = true;
      }

      if (!this.state.accept) {
        this.setState({ error1: true });
        error = true;
      } else {
        this.setState({ error1: false });
      }
      if (!error) {
        this.confirmForm();
      }
    }
    if (!error) {
      this.setState({ step: this.state.step + 1 });
    }
  };

  TextMaskDate = props => {
    const { inputRef, ...other } = props;

    return (
      <MaskedInput
        {...other}
        ref={ref => {
          inputRef(ref ? ref.inputElement : null);
        }}
        mask={[/\d/, /\d/, "/", /\d/, /\d/]}
        placeholderChar={"\u2000"}
        showMask
      />
    );
  };

  TextMaskCode = props => {
    const { inputRef, ...other } = props;

    return (
      <MaskedInput
        {...other}
        ref={ref => {
          inputRef(ref ? ref.inputElement : null);
        }}
        mask={
          this.state.tarjeta === "AMEX"
            ? [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]
            : [/[0-9]/, /[0-9]/, /[0-9]/]
        }
        placeholderChar={"0"}
        showMask
      />
    );
  };

  NumberFormatCustom = props => {
    const { inputRef, onChange, ...other } = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={values => {
          onChange({
            target: {
              value: values.value
            }
          });
        }}
        thousandSeparator
        prefix="$"
      />
    );
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };
  onClickReservar = () => {
    var error = false;

    if (
      this.state.reserva === "" ||
      this.state.tipoTarjeta === "" ||
      this.state.banco === "" ||
      this.state.tarjeta === "" ||
      this.state.numTarjeta === "" ||
      this.state.fechaVencimiento === "" ||
      this.state.codSeguridad === "" ||
      this.state.titularTarjeta === "" ||
      this.state.documentoTarjeta === "" ||
      this.state.emailContacto === "" ||
      this.state.emailContacto2 === "" ||
      this.state.areaTelefonoContacto === "" ||
      this.state.telefonoContacto === ""
    ) {
      this.setState({
        errorMessage: "*COMPLETAR TODOS LOS CAMPOS",
        error: true
      });
      error = true;
    } else if (this.state.emailContacto !== this.state.emailContacto2) {
      this.setState({ errorMessage: "*LOS E-MAILS NO COINCIDEN", error: true });
      error = true;
    } else if (parseInt(this.state.reserva) < 5000) {
      this.setState({
        errorMessage: "*EL MONTO MÍNIMO ES DE $5000",
        error: true
      });
      error = true;
    } else {
      this.setState({ errorMessage: "", error: false });
    }

    if (!this.state.accept) {
      this.setState({ error1: true });
      error = true;
    } else {
      this.setState({ error1: false });
    }
    if (!error) {
      this.confirmForm();
    }
  };

  confirmForm = () => {
    this.props.history.push("/carformconfirm");
  };

  render() {
    const classes = this.useStyles();
    this.NumberFormatCustom.propTypes = {
      inputRef: PropTypes.func.isRequired,
      onChange: PropTypes.func.isRequired
    };

    return (
      <div>
        <Header />
        <div className="GridCarForm">
          {isMobile ? <CarFormNumbers step={this.state.step} /> : null}

          <Grid container spacing={5} xs={12} sm={12}>
            <Grid container spacing={3} xs={12} sm={7}>
              {(isMobile && this.state.step == 1) || !isMobile ? (
                <React.Fragment>
                  <div
                    className={isMobile ? "CarFormTitleMobile" : "CarFormTitle"}
                  >
                    ¡Estás a un paso de que sea tuyo!
                    <br />
                    <div
                      className={isMobile ? "CarFormTextMobile" : "CarFormText"}
                    >
                      {" "}
                      Compartinos el monto con el que querés reservarlo. <br />
                      Recordá que el monto mínimo es de $5.000.
                    </div>
                  </div>
                  <Grid item xs={10} sm={11}>
                    <div
                      className={
                        isMobile
                          ? this.state.error === true &&
                            this.state.reserva === ""
                            ? "CarFormBoxMobileError"
                            : "CarFormBoxMobile"
                          : this.state.error === true &&
                            this.state.reserva === ""
                          ? "CarFormBoxError"
                          : "CarFormBox"
                      }
                    >
                      <div className="CarFormTitle2">¿Con cuanto reservás?</div>
                      <br />
                      <FormControl className="InputFormControl">
                        <InputLabel
                          shrink
                          htmlFor="monto-input"
                          className="Label"
                        >
                          Monto de la reserva
                        </InputLabel>
                        <TextField
                          placeholder="Recordá que el minimo es $5000."
                          id="monto-input"
                          value={this.state.reserva}
                          onChange={this.handleChange("reserva")}
                          InputProps={{
                            inputComponent: this.NumberFormatCustom
                          }}
                          className="TextInputBoot"
                          required
                        />
                      </FormControl>
                    </div>
                  </Grid>
                  {isMobile ? (
                    <React.Fragment>
                      <Grid item xs={12} sm={11}>
                        <div className="Error1">
                          {this.state.error ? this.state.errorMessage : null}
                        </div>
                        <div
                          className="SiguienteButtonForm"
                          onClick={this.next}
                        >
                          <img
                            src="/img/siguiente.png"
                            className="SiguienteImg"
                          />
                        </div>
                      </Grid>
                    </React.Fragment>
                  ) : null}
                </React.Fragment>
              ) : null}
              {(isMobile && this.state.step == 2) || !isMobile ? (
                <React.Fragment>
                  <div
                    className={
                      isMobile ? "CarFormTitle2Mobile" : "CarFormTitle"
                    }
                  >
                    Datos de Pago
                  </div>
                  <Grid item xs={10} sm={11}>
                    <div
                      className={
                        this.state.error === true &&
                        this.state.tipoTarjeta === ""
                          ? "CarFormBoxError"
                          : "CarFormBox"
                      }
                    >
                      <div className="CarFormTitle2">
                        ¿Con qué pagás la reserva?
                      </div>
                      <br />
                      <RadioGroup
                        aria-label="tipotarjeta"
                        name="tipotarjeta"
                        onChange={this.handleChange("tipoTarjeta")}
                        className={"RadioGroup"}
                      >
                        <FormControlLabel
                          value="credito"
                          control={<Radio />}
                          label="Tarjeta de crédito"
                          className="RadioLabel"
                        />
                        <div className="CarFormLine2"></div>
                        <FormControlLabel
                          value="debito"
                          control={<Radio />}
                          label="Tarjeta de débito"
                          className="RadioLabel"
                        />
                      </RadioGroup>
                    </div>
                  </Grid>

                  <Grid item xs={10} sm={11}>
                    <div
                      className={
                        this.state.error === true &&
                        (this.state.banco === "" ||
                          this.state.tarjeta === "" ||
                          this.state.numTarjeta === "" ||
                          this.state.fechaVencimiento === "" ||
                          this.state.codSeguridad === "" ||
                          this.state.titularTarjeta === "" ||
                          this.state.documentoTarjeta === "")
                          ? "CarFormBoxError"
                          : "CarFormBox"
                      }
                    >
                      <div className="CarFormTitle2">Datos de la Tarjeta</div>
                      <br />
                      <FormControl className="InputFormControl">
                        <InputLabel shrink htmlFor="bank" className="Label">
                          Banco
                        </InputLabel>
                        <Select
                          onChange={this.handleChange("banco")}
                          inputProps={{
                            name: "bank",
                            id: "bank"
                          }}
                          displayEmpty
                          name="bank"
                          className="SelectInput"
                          value={this.state.banco}
                        >
                          <MenuItem value="">
                            <em>
                              Seleccioná el banco al que pertenece tu tarjeta
                            </em>
                          </MenuItem>
                          {this.state.bancos
                            .filter((item, index) => {
                              return this.state.bancos.indexOf(item) === index;
                            })
                            .map(banco => (
                              <MenuItem value={banco}>{banco}</MenuItem>
                            ))}
                        </Select>
                      </FormControl>

                      <FormControl className="InputFormControlSub">
                        <InputLabel shrink htmlFor="card" className="Label">
                          Tarjeta
                        </InputLabel>
                        <Select
                          onChange={this.handleChange("tarjeta")}
                          inputProps={{
                            name: "card",
                            id: "card"
                          }}
                          name="age"
                          className="SelectInput"
                          value={this.state.tarjeta}
                        >
                          <MenuItem value="">
                            <em>Seleccioná tu tarjeta</em>
                          </MenuItem>
                          {this.state.tarjetas
                            .filter((item, index) => {
                              return item.banco === this.state.banco;
                            })
                            .map(tarjeta => (
                              <MenuItem value={tarjeta.tarjeta}>
                                {tarjeta.tarjeta}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>

                      <FormControl className="InputFormControlSub">
                        <InputLabel className="Label" shrink>
                          Número de la Tarjeta
                        </InputLabel>
                        <BootstrapInput
                          placeholder="Ingresá el número de tu tarjeta"
                          id="monto-input"
                          onChange={this.handleChange("numTarjeta")}
                        />
                      </FormControl>
                      <FormControl className="InputFormControlSub1">
                        <InputLabel
                          shrink
                          htmlFor="bank"
                          className={isMobile ? "LabelMobile" : "Label"}
                        >
                          Vencimiento
                        </InputLabel>
                        <Input
                          placeholder="MM/AA"
                          id="monto-input"
                          inputComponent={this.TextMaskDate}
                          className="CarFormInput"
                          onChange={this.handleChange("fechaVencimiento")}
                        />
                      </FormControl>
                      <FormControl className="InputFormControlSub2">
                        <InputLabel
                          shrink
                          htmlFor="bank"
                          className={isMobile ? "LabelMobile" : "Label"}
                        >
                          Cód. Seguridad
                        </InputLabel>
                        <Input
                          defaultValue="000"
                          id="monto-input"
                          inputComponent={this.TextMaskCode}
                          className="CarFormInput"
                          onChange={this.handleChange("codSeguridad")}
                        />
                      </FormControl>
                      <FormControl className="InputFormControlSub">
                        <InputLabel
                          shrink
                          className="Label"
                          htmlFor="monto-input"
                        >
                          Titular de la tarjeta
                        </InputLabel>
                        <BootstrapInput
                          placeholder="Como figura en la tarjeta."
                          id="monto-input"
                          onChange={this.handleChange("titularTarjeta")}
                        />
                      </FormControl>
                      <FormControl className="InputFormControlSub">
                        <InputLabel
                          shrink
                          htmlFor="bank"
                          className={isMobile ? "LabelMobile" : "Label"}
                        >
                          Documento del titular de la tarjeta
                        </InputLabel>
                        <BootstrapInput
                          placeholder="Ej.:30891632"
                          id="monto-input"
                          onChange={this.handleChange("documentoTarjeta")}
                        />
                      </FormControl>
                    </div>
                  </Grid>

                  {isMobile ? (
                    <React.Fragment>
                      <Grid item xs={12} sm={11}>
                        <div className="Error1">
                          {this.state.error ? this.state.errorMessage : null}
                        </div>
                        <div
                          className="SiguienteButtonForm"
                          onClick={this.next}
                        >
                          <img
                            src="/img/siguiente.png"
                            className="SiguienteImg"
                          />
                        </div>
                      </Grid>
                    </React.Fragment>
                  ) : null}
                </React.Fragment>
              ) : null}
              {(isMobile && this.state.step == 3) || !isMobile ? (
                <React.Fragment>
                  <div
                    className={
                      isMobile ? "CarFormTitle2Mobile" : "CarFormTitle"
                    }
                  >
                    Datos de Contacto
                  </div>
                  <Grid item xs={10} sm={11}>
                    <div
                      className={
                        this.state.error === true &&
                        (this.state.emailContacto === "" ||
                          this.state.emailContacto2 === "" ||
                          this.state.emailContacto !==
                            this.state.emailContacto2)
                          ? "CarFormBoxError"
                          : "CarFormBox"
                      }
                    >
                      <div className="CarFormTitle2">
                        Datos para envio de reserva:
                      </div>
                      <br />
                      <FormControl className="InputFormControl">
                        <InputLabel shrink className="Label">
                          E-mail
                        </InputLabel>
                        <BootstrapInput
                          placeholder="Ingresá un mail de contacto"
                          id="monto-input"
                          onChange={this.handleChange("emailContacto")}
                        />
                      </FormControl>
                      <FormControl className="InputFormControlSub">
                        <InputLabel shrink className="Label">
                          Confirma tu e-mail
                        </InputLabel>
                        <BootstrapInput
                          placeholder="Re-ingresá un mail de contacto"
                          id="monto-input"
                          onChange={this.handleChange("emailContacto2")}
                        />
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item xs={10} sm={11}>
                    <div
                      className={
                        this.state.error === true &&
                        (this.state.areaTelefonoContacto === "" ||
                          this.state.telefonoContacto === "")
                          ? "CarFormBoxError"
                          : "CarFormBox"
                      }
                    >
                      <div className="CarFormTitle2">Telefono de contacto:</div>
                      <FormControl className="InputFormControlSub1">
                        <InputLabel shrink className="Label">
                          Area
                        </InputLabel>
                        <BootstrapInput
                          placeholder="11"
                          id="monto-input"
                          onChange={this.handleChange("areaTelefonoContacto")}
                        />
                      </FormControl>
                      <FormControl
                        className="InputFormControlSub2"
                        style={{ width: "40%" }}
                      >
                        <InputLabel shrink className="Label">
                          Número
                        </InputLabel>
                        <BootstrapInput
                          placeholder="Ingresá un número"
                          id="monto-input"
                          onChange={this.handleChange("telefonoContacto")}
                        />
                      </FormControl>
                    </div>
                  </Grid>
                  {isMobile ? (
                    <React.Fragment>
                      <Grid item xs={10} sm={11}>
                        <div className="CheckDiv">
                          <Checkbox
                            checked={this.state.accept}
                            onChange={this.handleChangeCheck}
                            inputProps={{
                              "aria-label": "primary checkbox"
                            }}
                          />
                          <div className="TextCheck" onClick={this.handleOpen}>
                            Leí y acepto las condiciones de compra y políticas
                            de privacidad
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={11}>
                        <div className="Error1">
                          {this.state.error ? this.state.errorMessage : null}
                        </div>
                        <div className="Error1">
                          {this.state.error1
                            ? "*DEBE ACEPTAR TERMINOS Y CONDICIONES PARA CONTINUAR"
                            : null}
                        </div>
                        <div
                          className="SiguienteButtonForm"
                          onClick={this.next}
                        >
                          <img src="/img/listo.png" className="SiguienteImg" />
                        </div>
                      </Grid>
                    </React.Fragment>
                  ) : null}
                </React.Fragment>
              ) : null}
              {isMobile ? null : (
                <React.Fragment>
                  <Grid item xs={10} sm={11}>
                    <div className="CheckDiv">
                      <Checkbox
                        checked={this.state.accept}
                        onChange={this.handleChangeCheck}
                        inputProps={{
                          "aria-label": "primary checkbox"
                        }}
                      />
                      <div className="TextCheck" onClick={this.handleOpen}>
                        Leí y acepto las condiciones de compra y políticas de
                        privacidad
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={10} sm={11}>
                    <div className="Error1">
                      {this.state.error ? this.state.errorMessage : null}
                    </div>
                    <div className="Error1">
                      {this.state.error1
                        ? "*DEBE ACEPTAR TERMINOS Y CONDICIONES PARA CONTINUAR"
                        : null}
                    </div>
                    <div className="ReservarButtonForm">
                      <div onClick={this.onClickReservar}>
                        <img src="/img/reservar.png" className="ReservarImg" />
                      </div>
                    </div>
                  </Grid>
                </React.Fragment>
              )}
            </Grid>

            <div style={{ float: "right" }}>
              <CarFormDetail
                car={this.state.car}
                reserva={this.state.reserva}
              />
            </div>
          </Grid>
        </div>
        {isMobile ? (
          <div
            className={this.state.step == 1 ? "FooterMobile" : "FooterMobile2"}
          >
            <div
              className={
                this.state.step == 1 ? "FooterMontoLabel" : "FooterMontoLabels2"
              }
            >
              MONTO RESERVA:
            </div>
            <div
              className={this.state.step == 1 ? "FooterMonto" : "FooterMontos2"}
            >
              $0
            </div>
            <div
              className={
                this.state.step == 1
                  ? "FooterMontoLabel2"
                  : "FooterMontoLabels22"
              }
            >
              Detalle de compra
            </div>
          </div>
        ) : (
          <Footer />
        )}
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Terminos y condiciones"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              1- PEDIDO: La presente SOLICITUD DE RESERVA tiene el caracter de
              irrevocable e instransferible y la firma vendedora ser reserva la
              facultad de aceptarla o rechazarla en cualquier momento sin
              limitacion alguna entendiendose concretada la compra recien en el
              momento de entrega de la unidad y en el caso de que el comprador
              desistiese de la compra todo deposito efectuado en aplicacion a la
              misma quedara definitiva y automaticamente en poder de la firma
              vendedora como indemnizacion a excepcion de los casos previstos en
              los arts. 2do y 3ro. Los valores recibidos constituiran seña una
              recien cuando se emita recibo oficial.
              <br /> 2- PRECIO: Los precios de ventas consignados para la unidad
              y accesorios son los de la lista al publico actuales fijados por
              TOYOTA ARGENTINA S.A. y al igual que las condiciones de pagos
              propuestas, podran variarse en cualquier momento y sin previo
              aviso, rigiendo en este caso y para esta solicitud los nuevos
              precios de venta. En el caso de producirse esta eventualidad el
              comprador tendra derecho a anular su pedido y solicitar por nota
              el reintegro de los depositos efectuados dentro de los quince (15)
              dias subsiguientes a la fecha de variacion, los cuales seran
              puestos a disposicion en un plazo no mayor de treinta (30) dias,
              sin indemnizacion alguna. <br />
              3- FECHA DE ENTREGA: La fecha de entrega indicada es meramente
              informativa y no compromete a la firma vendedora a su cumplimiento
              cuando se originen atrasos en los despachos de fabrica,
              inconvenientes en los transportes, huelgas u otras causas de
              fuerza mayor, y toda otra circunstancia equivalente. Pasados
              noventa (90) dias de esa fecha, el comprador podra dentro de los
              quince (15) dias subsiguientes, dejar sin efecto su pedidos con
              derecho a reintegro de todo deposito efectuado, sin indemnizacion
              alguna. Vencido este termino, el mismo quedara prorrogado
              automaticamente por un nuevo periodo. <br />
              4- ESPECIFICACIONES: TOYOTA ARGENTINA S.A. se reserva el pleno
              derecho de cancelar la produccion, revisar, suspender o alterar
              las especificaciones tecnicas de sus vehiculos o cualquier pieza
              de los mismos en cualquier momento y sin previo aviso, sin que la
              fabrica ni la firma vendedora asuma la responsabilidad o
              compromiso alguno con el comprador, no estando tampoco obligada a
              aplicar a las unidades ya construidas o en proceso de
              construccion, las modificaciones que hubiesen sido proyectadas al
              recibo de esta solicitud. <br />
              5- FINANCIACION: En las operaciones en que se convenga acordar
              facilidades para el pago del precio de venta, el comprador se
              obliga a gravar la unidad adquirida con garantia prendaria en
              primer grado por el saldo del precio mas los gastos de
              financiacion a favor del vendedor o entidad financiera, en su
              caso. A los efectos de considerar la respectiva SOLICITUD DE
              CREDITO, la firma vendedora queda autorizada a recabar informes
              comerciales, bancarios, particulares, etc., que estima necesarios
              y en caso de proceder a su rechazo o comprobar falsedad en los
              datos suministrados, retendra de todo deposito realizado, los
              gastos incurridos. <br />
              6- SEGURO: En las operaciones financiadas el comprador queda
              obligado a contratar una poliza de seguro por ante la compañia
              aseguradora que designe la firma vendedora o entidad financiera,
              contra todo riesgo, inclusive huelgas, hechos belicos, tumultos,
              inundaciones, terremotos y granizos y mantener vigente dicha
              poliza por todo el periodo de la financiacion. En el acto de tomar
              posesion del bien adquirido, el comprador debera entregar a la
              firma vendedora el original de la poliza debidamente endosada,
              conjuntamente con el recibo oficial que justifique el pago total
              de la prima. <br />
              7- ENTREGA: El comprador debera retirar y abonar totalmente la
              unidad adquirida y los gastos correspondientes dentro de los diez
              (10) dias desde la comunicacion respectiva. Vencido dicho termino
              y por el solo transcurso del tiempo y sujeto a lo dispuesto en el
              art. 1ro para el supuesto de anulacion por parte del comprador.{" "}
              <br />
              8- UNIDAD USADA: El valor de toda unidad usada ofrecida como parte
              de pago sera acreditado por la firma vendedora unicamente en caso
              de recibir la misma dentro de las venticuatro (24) horas
              subsiguientes de haberse formalizado el respectivo pedido por la
              unidad nueva, caso contrario el peritaje efectuado tiene caracter
              "INFORMATIVO", y sujeto a una revalidacion, siendo en este caso
              facultad privativa del vendedor aceptar o rechazar la unidad
              usada. Al valor convenido se deducira el impuesto a la
              transferencia de Automoviles Usados (Ley 21.432).
              <br />
              9- Todos los pagos que demande el transporte de la unidad, gastos
              e impuestos por patentamiento y la constitucion de prenda, corren
              por exclusiva cuenta del comprador. <br />
              10- Cualquier error en las condiciones o en las sumas que figure
              en el presente pedido, en caso de comprobarse posteriormente, se
              ajustaran a su real valor.
              <br />
              11- Cuando la firma vendedora tenga disponible el vehiculo
              solicitado, notificara tal circunstancia al comprador, quien
              debera hacerse presente para formalizar y ajustar las condiciones
              pendientes de la operacion dentro de los tres (3) dias habiles de
              recibila la notificacion, en cado de que el comprador no compareza
              en el plazo indicado o no cumpla con las condiciones pactadas en
              el lapso de dos (2) dias habiles posteriores a la formalizacion de
              la compra perdera el derecho al turno de entrega pasando a una
              lista de espera, sin perjuicio de las demas estipulaciones
              contractuales contenidas en el presente. <br />
              12- Los valores recibidos en deposito por la presente solicitud de
              reserva se acreditaran unicamente con la emision del recibo
              oficial correspondiente. <br />
              13- En caso de falta de pago del precio por parte del comprador en
              los plazos estipulados, se producira su mora de pleno derecho, la
              caducidad de los plazos pendientes y consecuentemente la rescision
              de la compra celebrada, pudiendo AUTOPRANA S.A. disponer del
              automovil para otro interesado.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="secondary">
              No Acepto
            </Button>
            <Button onClick={this.handleAccept} color="secondary" autoFocus>
              Acepto
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default CarForm;
